// src/pages/admin/Dashboard.js
const Dashboard = () => <h1>Admin Dashboard</h1>;
export default Dashboard;
